import { render } from "./BackButton.vue?vue&type=template&id=19728a9a&scoped=true"
import script from "./BackButton.vue?vue&type=script&lang=js"
export * from "./BackButton.vue?vue&type=script&lang=js"

import "./BackButton.vue?vue&type=style&index=0&id=19728a9a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-19728a9a"

export default script